import { createFileRoute } from '@tanstack/react-router'

import type { TCardStatusFilter, TShareStatusFilter } from '#pages/AnonymousCards/shared/interfaces'
import { mapLegacySharedCardSearch } from '#pages/AnonymousCards/shared/legacySearch'

interface ISharedCardsSearch {
  sortBy?: string
  sortDir?: 'asc' | 'desc'
  cardStatus?: TCardStatusFilter
  shareStatus?: TShareStatusFilter
}

export const Route = createFileRoute('/_authenticated/shared-cards')({
  validateSearch: (search: Record<string, unknown>): ISharedCardsSearch => {
    const mapped = mapLegacySharedCardSearch(search, 'shareStatus')

    return {
      sortBy: typeof search.sortBy === 'string' && search.sortBy.length > 0 ? search.sortBy : undefined,
      sortDir: search.sortDir === 'asc' || search.sortDir === 'desc' ? search.sortDir : undefined,
      // Always present, including undefined. TanStack Router merges this result
      // over the raw search, so an omitted key would keep an unknown value.
      cardStatus: mapped.cardStatus,
      shareStatus: mapped.shareStatus,
    }
  },
})
